import { ReactElement } from 'react';
import { FooterBlockProps } from './FooterBlock.domain';
import { Link } from '@/common/ui';
import * as S from './FooterBlock.styles';

export const FooterBlock = ({ title, isOpen, toggle, list }: FooterBlockProps): ReactElement => {
    return (
        <S.Container>
            <S.Title onClick={toggle}>
                {title}
                <S.Arrow isActive={isOpen} />
            </S.Title>
            {isOpen &&
                list.map(({ href, name, rel }) => (
                    <Link key={name} href={href.toLowerCase()} passHref prefetch={false}>
                        <S.Item rel={rel}>{name}</S.Item>
                    </Link>
                ))}
        </S.Container>
    );
};
